var map = {
	"./collections.de-CH.json": 1653,
	"./collections.de-DE.json": 1654,
	"./collections.en-CA.json": 1655,
	"./collections.en-GB.json": 1656,
	"./collections.en-IN.json": 1657,
	"./collections.en-ME.json": 1658,
	"./collections.en-US.json": 1659,
	"./collections.es-EM.json": 1660,
	"./collections.es-ES.json": 1661,
	"./collections.fr-BE.json": 1662,
	"./collections.fr-CA.json": 1663,
	"./collections.fr-CH.json": 1664,
	"./collections.nl-BE.json": 1665,
	"./collections.nl-NL.json": 1666,
	"./collections.pl-PL.json": 1667,
	"./collections.pt-BR.json": 1668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1652;